<style lang="scss" src="./style.scss" scoped></style>
<script src="./script"></script>
<template>
  <breadcrumb :links="breadcrumb"></breadcrumb>
  <div class="page page-list">
    <div class="page-header p-3">
      <div class="header-control">
        <div>
          <h1 class="text-warning">Quản lí CPDs</h1>
        </div>
        <div>
          <div class="search-query">
            <input type="text" class="form-control form-control-sm" placeholder="Nhập từ khóa tìm kiếm của bạn"
              v-model="filter.q" @change="onChangeFilter('q')">
          </div>
          <filter-dropdown class="mx-1" :badge="countFilter">
            <div class="filter-content p-3">
              <div class="search-query-sm mb-3">
                <input type="text" class="form-control form-control-sm" placeholder="Nhập từ khóa tìm kiếm của bạn"
              v-model="filter.q" @change="onChangeFilter('q')">
              </div>
              <h6>Trạng thái hiển thị:</h6>
            <div class="d-flex mb-3">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" :checked="filter.display.includes(0)" @change="onChangeFilter('display', $event, 0)" id="filter-display-off"> <label for="filter-display-off">Không hiển thị</label>
              </div>

              <div class="form-check mx-2">
                <input class="form-check-input" type="checkbox" :checked="filter.display.includes(1)" @change="onChangeFilter('display', $event, 1)" id="filter-display-on"> <label for="filter-display-on">Hiển thị</label>
              </div>
            </div>

            <h6>Trạng thái hoạt động:</h6>
            <div class="d-flex mb-3">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" :checked="filter.active.includes(0)" @change="onChangeFilter('active', $event, 0)" id="filter-active-off"> <label for="filter-active-off">Không hoạt động</label>
              </div>

              <div class="form-check mx-2">
                <input class="form-check-input" type="checkbox" :checked="filter.active.includes(1)" @change="onChangeFilter('active', $event, 1)" id="filter-active-on"> <label for="filter-active-on">Hoạt động</label>
              </div>
            </div>

            <h6>Thời gian:</h6>
            <div class="d-flex mb-3">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" :checked="filter.expired.includes(0)" @change="onChangeFilter('expired', $event, 0)" id="filter-expired-off"> <label for="filter-expired-off">Còn hạn</label>
              </div>

              <div class="form-check mx-2">
                <input class="form-check-input" type="checkbox" :checked="filter.expired.includes(1)" @change="onChangeFilter('expired', $event, 1)" id="filter-expired-on"> <label for="filter-expired-on">Hết hạn</label>
              </div>
            </div>

            <div class="row">
              <div class="col col-12 col-md-6 mb-3">
                <h6>Brand:</h6>
                <div>
                  <multi-select :mappingKeys="{label: 'name', value: 'name', description: 'code', keywords: 'code'}" type="string" :data="master.brands" label="Brand" v-model="filter.brand" :style="{width: '100%'}" @change="onChangeFilter('brand')"></multi-select>
                </div>
              </div>

              <div class="col col-12 col-md-6 mb-3">
                <h6>Đối tác:</h6>
                <div>
                  <multi-select type="string" :data="master.cpd.partners" label="Đối tác" v-model="filter.partner" :style="{width: '100%'}" @change="onChangeFilter('partner')"></multi-select>
                </div>
              </div>
            </div>
            <div class="row" v-if="user.role !== 'MEMBER'">
              <div class="col col-12 col-md-6 mb-3">
                <h6>Người tạo:</h6>
                <div>
                  <multi-select :mappingKeys="{label: 'name', value: 'id'}" type="string" :data="master.cpd.users" label="User" v-model="filter.user" :style="{width: '100%'}" @change="onChangeFilter('user')"></multi-select>
                </div>
              </div>
            </div>
            <div class="mt-3" style="text-align: right; font-weight: bold;"><a href="javascript: void(0)" @click="resetFilter()"><i class="fa fa-trash"></i> Bộ lộc mặc định</a></div>
            </div>
          </filter-dropdown>
          <group-dropdown label="Hành động" icon="fa fa-list">
            <button class="btn btn-sm btn-success" @click="openModalEmbed()" :disabled="checkedlist.length == 0"><i class="fa-solid fa-code"></i> Mã nhúng</button>
            <div class="btn-group btn-group-sm" v-if="pages.cpd_crud">
              <button type="button" :disabled="checkedlist.length == 0" class="btn btn-warning dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                <i class='bx bx-export'></i> Trạng thái
              </button>
              <ul class="dropdown-menu">
                <li><a class="dropdown-item" href="#" @click="onActive(false)">Tạm dừng hoạt động</a></li>
                <li><a class="dropdown-item" href="#" @click="onActive(true)">Hoạt động</a></li>
              </ul>
            </div>
            <button class="btn btn-sm btn-build"  v-if="pages.cpd_crud" @click="onRender(false)"><i class="fa-solid fa-pen-nib"></i> Build</button>
            <button class="btn btn-sm btn-primary" @click="openModalCreate()" v-if="pages.cpd_crud"><i class="fa fa-plus"></i> Tạo mới</button>
          </group-dropdown>
        </div>
      </div>
    </div>
    <overlay class="page-body px-3" :loading="isSearching">
      <div class="table-responsive">
        <table class="table fixed-left fixed-right table-striped" v-if="result">
          <thead>
            <tr>
              <th>
                <div class="form-check" v-if="result.data.length">
                  <input class="form-check-input" type="checkbox" @click="checkall()"
                    :checked="checkedlist.length == result.data.length">
                </div>
              </th>
              <th></th>
              <th>Hiển thị</th>
              <th>Trạng thái</th>
              <th>Tên CPD</th>
              <th>Brand</th>
              <th>Lần chạy</th>
              <th>Key liên kết</th>
              <th>Đối tác</th>
              <th>Tags</th>
              <th>Vị trí</th>
              <th>Thiết bị</th>
              <th>Ngày bắt đầu</th>
              <th>Ngày kết thúc</th>
              <th>Cost</th>
              <th>Discount</th>
              <th>Ghi chú</th>
              <th v-if="user.role !== 'MEMBER'">Người tạo</th>
              <th v-if="user.is_admin || (user.role == 'MANAGER' && !user.team_id)">Team</th>
              <th class="action"></th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(item, i) in result.data" :key="i">
              <td>
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" @click="toggleCheckbox(item.id)"
                    :checked="checkedlist.includes(item.id)">
                </div>
              </td>
              <td>
                <div class="thumbnail thumbnail-sm" :style="{backgroundImage: `url(${$filters.getFileUrl((item.content.mobile || item.content.pc).src)})`}">
                  <div class="review">
                    <div><img :src="$filters.getFileUrl((item.content.mobile || item.content.pc).src)"></div>
                  </div>
                </div>
              </td>
              <td v-if="!pages.cpd_crud">
                <span class="text-success" v-if="item.display"><i class="fa fa-check-circle"></i> Đang bật</span>
                <span class="text-secondary" v-else><i class="fa fa-check-circle"></i> Đang tắt</span>
              </td>
              <td v-else>
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" role="switch" :id="'displaySw' + i" @click="onToggleDisplay(item)" :checked="!!item.display">
                  <label class="form-check-label" :for="'displaySw' + i"> 
                    <span class="text-success" v-if="item.display"> Đang bật</span>
                    <span class="text-secondary" v-else> Đang tắt</span>
                  </label>
                </div>
              </td>
              <td>
                <span class="text-success" v-if="item.active"><i class="fa fa-check-circle"></i> Hoạt động</span>
                <span class="text-secondary" v-else><i class="fa fa-check-circle"></i> Không hoạt động</span>
              </td>
              <td>{{ item.name }}</td>
              <td>{{ item.brand_name }}</td>
              <td>
                <span v-if="item.times > 1"><a href="javascript: void(0)" class="text-primary" @click="openHistory(item)">Xem lịch sử ({{ item.times }} lần)</a></span>
                <span v-else>Lần đầu</span>
              </td>
              <td><a :href="$filters.getExternalUrl(item)" target="_blank">{{ item.external_key }} <i class='bx bx-link'></i></a>
              </td>
              <td>{{ item.partner_name }}</td>
              <td><span class="tag bg-primary" v-for="(tag, j) in item.tags" :key="j">{{ tag }}</span></td>
              <td><span class="tag bg-success">{{ item.position }}</span></td>
              <td><span class="tag bg-warning" v-for="(tag, j) in $filters.getDevice(item.content)" :key="j">{{ tag }}</span></td>
              <td>{{ item.start_at || '-' }}</td>
              <td>{{ item.end_at || '-' }}</td>
              <td>{{ $filters.comma(item.cost) }}</td>
              <td>{{ $filters.comma(item.discount) }}</td>
              <td>{{ item.note }}</td>
              <td v-if="user.role !== 'MEMBER'">{{ item.user.name }}</td>
              <td v-if="user.is_admin || (user.role == 'MANAGER' && !user.team_id)">{{ item.team.name }}</td>
              <td class="action" v-if="pages.cpd_crud">
                <a title="Tiếp tục chạy quảng cáo mới với CPD này" href="javascript: void(0)" @click="onNewRef(item, i)"><i class="bx bx-plus-medical text-info"></i></a>
                <a title="Mã nhúng" href="javascript: void(0)" @click="openModalEmbed([item])"><i class="fa-solid fa-code text-success"></i></a>
                <a title="Clone bản mới" href="javascript: void(0)" @click="onClone(item)"><i class="fa-solid fa-copy text-warning"></i></a>
                <a title="Chỉnh sửa" href="javascript: void(0)" @click="openModalUpdate(item)"><i class="fa fa-edit"></i></a>
              </td>
              <td class="action" v-if="!pages.cpd_crud">
                <a title="Mã nhúng" href="javascript: void(0)" @click="openModalEmbed([item])"><i class="fa-solid fa-code text-success"></i></a>
                <a title="Chỉnh sửa" href="javascript: void(0)" @click="openModalUpdate(item)"><i class="fa fa-eye"></i></a>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="py-2 px-3" v-if="result && result.data.length == 0">
          Không có dữ liệu
        </div>
      </div>
    </overlay>

    <div class="page-footer p-3">
      <div v-if="result">
        Hiển thị {{result.data.length}} ({{ result.from }} - {{ result.to }})/{{ result.total }}, Trang {{ result.current_page }}/{{ result.last_page }} | {{ checkedlist.length }} được chọn
      </div>
      <b-pagination :data="result" v-if="result" @change="onChangePage"></b-pagination>
    </div>
  </div>

  <b-modal ref="crudModal" :options="crudOptions" class="modal-xl">
    <div class="modal-header">
      <h5 class="modal-title" v-if="!this.crudForm.id"><i class="fa fa-pencil"></i> Tạo mới CPD</h5>
      <h5 class="modal-title" v-else-if="pages.cpd_crud"><i class="fa fa-edit"></i> Chỉnh sửa thông tin CPD</h5>
      <h5 class="modal-title" v-else><i class="fa fa-eye"></i> Xem chi tiết CPD</h5>
      <button type="button" class="btn btn-cls" data-bs-dismiss="modal"><i class="fa fa-remove"></i></button>
    </div>

    <div class="modal-body">
      <div class="crudtabs">
        <div class="tab" :class="{ active: crudtab == 'info' }">Thông tin</div>
        <div class="tab"><i class='bx bx-chevrons-right'></i></div>
        <div class="tab" :class="{ active: crudtab == 'content' }">Hình ảnh</div>
      </div>
      <div class="row" v-if="crudtab == 'info'">
        <div class="col col-12 col-md-6 mb-3">
          <label>Tên (<span class="text-danger">*</span>)</label>
          <input class="form-control" type="text" placeholder="Tên CPD" v-model="crudForm.name"
            :class="{ 'border-danger': crudForm.errors.name }" :readonly="!pages.cpd_crud"/>
          <div class="msg-error" v-if="crudForm.errors.name">{{ crudForm.errors.name[0] }}</div>
        </div>

        <div class="col col-12 col-md-3 mb-3">
          <label>Cost</label>
          <format-mask :readonly="!pages.cpd_crud" v-model="crudForm.cost" placeholder="Cost" class="form-control" :class="{ 'border-danger': crudForm.errors.cost }"></format-mask>
          <div class="msg-error" v-if="crudForm.errors.cost">{{ crudForm.errors.cost[0] }}</div>
        </div>

        <div class="col col-12 col-md-3 mb-3">
          <label>Discount</label>
          <format-mask :readonly="!pages.cpd_crud" v-model="crudForm.discount" placeholder="Discount" class="form-control" :class="{ 'border-danger': crudForm.errors.discount }"></format-mask>
          <div class="msg-error" v-if="crudForm.errors.discount">{{ crudForm.errors.discount[0] }}</div>
        </div>

        <div class="col col-12 col-md-6">
          <label>Ngày bắt đầu ~ kêt thúc</label>
          <div class="row">
            <div class="col col-12 col-md-6 mb-3">
              <date-picker v-model="crudForm.start_at" :class="{ 'has-error': crudForm.errors.start_at }"
                :format="formatDatePicker" :disabled="!pages.cpd_crud"></date-picker>
              <div class="msg-error" v-if="crudForm.errors.start_at">{{ crudForm.errors.start_at[0] }}</div>
            </div>
            <div class="col col-12 col-md-6 mb-3">
              <date-picker v-model="crudForm.end_at" :class="{ 'has-error': crudForm.errors.end_at }"
                :format="formatDatePicker" :disabled="!pages.cpd_crud"></date-picker>
              <div class="msg-error" v-if="crudForm.errors.end_at">{{ crudForm.errors.end_at[0] }}</div>
            </div>
          </div>
        </div>

        <div class="col col-md-6">
          <label>Thời gian đặc biệt from ~ to</label>
          <div class="row">
            <div class="col col-12 col-md-6 mb-3">
              <input :readonly="!pages.cpd_crud" class="form-control" type="text" placeholder="H:m" v-model="crudForm.from"
                :class="{ 'border-danger': crudForm.errors.from }" />
              <div class="msg-error" v-if="crudForm.errors.from">{{ crudForm.errors.from[0] }}</div>
            </div>

            <div class="col col-12 col-md-6 mb-3">
              <input :readonly="!pages.cpd_crud" class="form-control" type="text" placeholder="H:m" v-model="crudForm.to"
                :class="{ 'border-danger': crudForm.errors.to }" />
              <div class="msg-error" v-if="crudForm.errors.to">{{ crudForm.errors.to[0] }}</div>
            </div>
          </div>
        </div>

        <div class="col col-12 mb-3" v-if="pages.cpd_crud">
          <div class="des"><i class='bx bx-help-circle'></i> Vui lòng nhập thời gian theo UTC+7.</div>
        </div>

        <div class="col col-12 col-md-4 mb-3">
          <label>Tên đối tác (<span class="text-danger">*</span>)</label>
          <input v-if="!pages.cpd_crud" class="form-control" type="text" v-model="crudForm.partner_name" :readonly="true"/>
          <multi-select :class="{ 'border-danger': crudForm.errors.partner_name }" v-else type="string" :data="master.cpd.partners" v-model="crudForm.partner_name" :max="1" :style="{width: '100%'}" :addable="true" @add="onAddMultiSelect('partner', $event)" :required="true"  @change="changeMul('partner')"></multi-select>
          <div class="msg-error" v-if="crudForm.errors.partner_name">{{ crudForm.errors.partner_name[0] }}</div>
          <div class="help text-primary" v-if="pages.cpd_crud"><i>Tìm kiếm trong danh sách hoặc thêm mới</i></div>
        </div>

        <div class="col col-12 col-md-4 mb-3">
          <label>Tags (<span class="text-danger">*</span>)</label>
          <input v-if="!pages.cpd_crud || !crudForm.partner_name" class="form-control" type="text" :value="crudForm.tags.join(',')" :readonly="true"/>
          <multi-select :class="{ 'border-danger': crudForm.errors.tags }" v-else :data="tags" v-model="crudForm.tags" :style="{width: '100%'}" :addable="true" :required="true" @add="onAddMultiSelect('tags', $event)" @change="changeMul('tags')"></multi-select>
          <div class="msg-error" v-if="crudForm.errors.tags">{{ crudForm.errors.tags[0] }}</div>
          <div class="help text-primary" v-if="pages.cpd_crud"><i>Tìm kiếm trong danh sách hoặc thêm mới</i></div>
        </div>

        <div class="col col-12 col-md-4 mb-3">
          <label>Key vị trí (<span class="text-danger">*</span>)</label>
          <input v-if="!pages.cpd_crud" class="form-control" type="text" v-model="crudForm.position" :readonly="true"/>
          <multi-select :class="{ 'border-danger': crudForm.errors.position }" v-else type="string" :data="positions" v-model="crudForm.position" :max="1" :style="{width: '100%'}" :addable="true" @add="onAddMultiSelect('position', $event)" :required="true"></multi-select>
          <div class="msg-error" v-if="crudForm.errors.position">{{ crudForm.errors.position[0] }}</div>
          <div class="help text-primary" v-if="pages.cpd_crud"><i>Tìm kiếm trong danh sách hoặc thêm mới</i></div>
        </div>

        <div class="col col-12 mb-3">
          <div class="des">
            <div><i class='bx bx-help-circle'></i> Giải thích:</div>
            <div><b>Tags:</b> để định danh link [script] dành cho đối tác khi xuất bản. Các CPDs cùng 1 đối tác thì nên đặt cùng tag, tất cả CPDs cùng tag thì chỉ cần nhúng 1 link script. Đặt tên tag tốt nhất nên có tiền tố phía trước theo đối tác để tránh trường hợp đặt tên trùng sau này.</div>
            <div><b>Key vị trí:</b> tự định nghĩa hoặc từ phía đối tác cung cấp, ứng với mỗi key vị trí thì CPDs sẽ tự động được hiển thị ở nơi có key này trên site đối tác.</div>
          </div>
        </div>

        <div class="col col-12 mb-3">
          <label>Domains hiển thị CPD (<span class="text-danger">*</span>)</label>
          <tags-input :tags="crudForm.partner_domains" @on-tags-changed="onChangeTags('partner_domains', $event)"
            :add-tag-on-keys="[9,32,13]"
            :class="{ 'border-danger': crudForm.errors.partner_domains, 'v3ti-pur': true }" :read-only="!pages.cpd_crud"></tags-input>
          <div class="msg-error" v-if="crudForm.errors.partner_domains">{{ crudForm.errors.partner_domains[0] }}</div>
          <div class="help text-primary" v-if="pages.cpd_crud"><i>Nhấn TAB, ENTER hoặc SPACE để thêm</i></div>
        </div>

        <div class="col col-12 col-md-6 mb-3">
          <label>Tên brand (<span class="text-danger">*</span>)</label>
          <input v-if="!pages.cpd_crud" class="form-control" type="text" v-model="crudForm.brand_name" :readonly="true"/>
          <multi-select :class="{ 'border-danger': crudForm.errors.brand_name }" v-else :mappingKeys="{label: 'name', value: 'name', description: 'code', keywords: 'code'}" type="string" :data="master.brands" label="Brand" v-model="crudForm.brand_name" :max="1" :style="{width: '100%'}" @change="onChangeBrand(true)" :required="true"></multi-select>
          <div class="msg-error" v-if="crudForm.errors.brand_name">{{ crudForm.errors.brand_name[0] }}</div>
        </div>

        <div class="col col-12 col-md-6 mb-3">
          <label>Key liên kết tool domain (<span class="text-danger">*</span>)</label>
          <input v-if="!pages.cpd_crud" class="form-control" type="text" v-model="crudForm.external_key" :readonly="true"/>
          <multi-select :class="{ 'border-danger': crudForm.errors.external_key }" v-else :mappingKeys="{label: 'key', value: 'key'}" type="string" :data="domains" label="Key" v-model="crudForm.external_key" :max="1" :style="{width: '100%'}" :required="true"></multi-select>
          <div class="msg-error" v-if="crudForm.errors.external_key">{{ crudForm.errors.external_key[0] }}</div>
        </div>

        <div class="col col-12 mb-3">
          <div class="des"><i class='bx bx-help-circle'></i> Danh sách brands, key liên kết được lấy từ <a :href="externalDomain"
                style="text-decoration: underline;" target="_blank">tool domain</a>. Sử dụng tool domain để cập nhật danh
              sách này.</div>
        </div>

        <div class="col col-12 mb-3">
          <label>Tracking query</label>
          <input class="form-control" type="text" :placeholder="trackingQueryPlaceholder" v-model="crudForm.tracking_query"
            :class="{ 'border-danger': crudForm.errors.tracking_query }" :readonly="!pages.cpd_crud"/>
          <div class="msg-error" v-if="crudForm.errors.tracking_query">{{ crudForm.errors.tracking_query[0] }}</div>
          <div class="help text-primary" v-if="pages.cpd_crud"><i>Để trống mặc định sẽ lấy từ key liên kết, điền thông tin tracking query nếu bạn muốn bổ sung hoặc custom</i></div>
        </div>

        <div class="col col-12 mb-3">
          <label>Ghi chú</label>
          <textarea :readonly="!pages.cpd_crud" class="form-control" v-model="crudForm.note"
            :class="{ 'border-danger': crudForm.errors.note }"></textarea>
          <div class="msg-error" v-if="crudForm.errors.note">{{ crudForm.errors.note[0] }}</div>
        </div>
      </div>
      <div v-if="crudtab == 'content'">
        <div class="select-device input-group input-group-sm mb-3" v-if="crudtab == 'content'">
          <span class="input-group-text">Thiết bị</span>
          <select class="form-control" v-model="imageTab">
            <option value="pc">PC</option>
            <!-- <option value="tablet">Tablet</option> -->
            <option value="mobile">Mobile</option>
          </select>
        </div>
        <div class="ads-review">
          <div class="no-image" v-if="!crudForm.content[imageTab]">
            <div v-if="pages.cpd_crud" class="text-center">
              <button class="btn btn-sm btn-primary" @click="onOpenFile()"><i class="fa-solid fa-upload"></i> Upload</button>
              <div v-if="availableImage" class="mt-3 text-center">HOẶC</div>
              <div v-if="availableImage" class="mt-2">
                <a href="javascript: void(0)" @click="useImage(availableImage.content)">Sử dụng ảnh của {{ availableImage.type }}</a>
              </div>
            </div>
            <div v-else>Chưa có hình ảnh</div>
          </div>
          <div class="hover" v-else>
            <span @click="openAdsReview()"><img :src="$filters.getFileUrl(crudForm.content[imageTab].src)"
                :alt="crudForm.name" /></span>
            <button @click="onRemoveImage()" v-if="pages.cpd_crud"><i class='fa fa-close'></i></button>
          </div>
        </div>
        <div class="des-review" v-if="crudForm.content[imageTab]"><span>Hình ảnh xem trước, kích thước {{
          crudForm.content[imageTab].size.replace(',', 'x') }}, CLICK vào hình ảnh để xem trang</span></div>
        <input type="file" class="d-none" ref="file" @change="onUploadFile" />
      </div>
    </div>

    <div class="modal-footer">
      <button class="btn btn-sm btn-secondary" v-if="crudtab == 'content'" @click="crudtab = 'info'"><i
          class='bx bx-chevrons-left'></i> Quay lại</button>
      <button class="btn btn-sm btn-primary" v-if="crudtab == 'info'" @click="crudtab = 'content'"
        :disabled="!canNext">Hình ảnh <i class='bx bx-chevrons-right'></i></button>
      <button class="btn btn-sm btn-primary" v-if="crudtab == 'content' && pages.cpd_crud" @click="onSaveCrud()"
        :disabled="!crudForm.content['mobile'] && !crudForm.content['pc'] && !crudForm.content['tablet']">Chỉ lưu</button>
      <button class="btn btn-sm btn-success" v-if="crudtab == 'content' && pages.cpd_crud" @click="onSaveCrud(true)"
        :disabled="!crudForm.content['mobile'] && !crudForm.content['pc'] && !crudForm.content['tablet']">Lưu & lấy mã</button>
    </div>
  </b-modal>

  <b-modal ref="exportModal" :options="crudOptions" class="modal-xl">
    <div class="modal-header">
      <h5 class="modal-title">Mã nhúng</h5>
      <button type="button" class="btn btn-cls" data-bs-dismiss="modal"><i class="fa fa-remove"></i></button>
    </div>
    <div class="modal-body">
      <div class="export-embed" v-for="(item, i) in exportResult" :key="i">
        <div class="rs-head d-flex">
          <label class="text-info" style="font-size: 1.4rem; display: block; flex: 1">#{{ i }}</label>
          <div>
            <div class="btn-group btn-group-sm">
              <button class="btn btn-sm" v-for="tab in item.tabs" :key="tab" @click="item.tab = tab" :class="{'btn-success': tab == item.tab, 'btn-secondary': tab != item.tab}">{{ tab }}</button>
            </div>
          </div>
        </div>
        <div v-if="item.tab == 'script'">
          <div class="rs-head2">
            <span class="text-warning" style="font-size: 0.9rem;"><i>Thẻ vị trí</i></span>
            <button @click="onCopyToLipboard(`pos_${i}`)"><i class='bx bx-copy'></i></button>
          </div>
          <div class="mt-1 mb-2">
            <div contenteditable="true" :ref="`pos_${i}`" class="form-control"><div v-for="p in item.script.position" :key="p">{{ '<div data-cpd-position="'+p+'"></div>' }}</div></div>
          </div>
          <div class="rs-head2">
            <span class="text-success" style="font-size: 0.9rem;"><i>Thẻ script</i></span>
            <button @click="onCopyToLipboard(`script_${i}`)"><i class='bx bx-copy'></i></button>
          </div>
          <div class="mt-1">
            <div contenteditable="true" :ref="`script_${i}`" class="form-control"><div v-for="link in item.script.links" :key="link">{{ '<script type="text/javascript" data-cpd-script="'+link+'" src="' + $filters.getFileUrl(link + '/load.js')  + '"></script>' }}</div></div>
          </div>
        </div>
        <div v-if="item.tab == 'iframe'">
          <div class="mt-1 mb-2" v-for="(link, p) in item.iframe" :key="p">
            <div class="rs-head2">
              <span class="text-success" style="font-size: 0.9rem;"><i>{{ p }}</i></span>
              <button @click="onCopyToLipboard(`iframe_${i}`)"><i class='bx bx-copy'></i></button>
            </div>
            <div contenteditable="true" :ref="`iframe_${i}`" class="form-control mt-1">{{ '<iframe frameborder="0" width="100%" height="100%" src="' + $filters.getFileUrl('iframe/' + link + '.html') + '"></iframe>' }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-sm btn-secondary" data-bs-dismiss="modal">Đóng</button>
    </div>
  </b-modal>

  <b-modal ref="historyModal" class="modal-xl">
    <div class="modal-header">
      <h5 class="modal-title">Lịch sử đặt quảng cáo</h5>
      <button type="button" class="btn btn-cls" data-bs-dismiss="modal"><i class="fa fa-remove"></i></button>
    </div>
    <div class="modal-body pt-0" v-if="history.item">
      <div class="d-flex mb-3">
        <div>
          <div class="thumbnail" :style="{backgroundImage: `url(${$filters.getFileUrl((history.item.content.mobile || history.item.content.pc).src)})`}">
            <div class="review">
              <div><img :src="$filters.getFileUrl((history.item.content.mobile || history.item.content.pc).src)"></div>
            </div>
          </div>
        </div>
        <div class="px-3">
          <div><b>Tên CPD:</b> {{ history.item.name }}</div>
          <div><b>Brand:</b> {{ history.item.brand_name }}</div>
          <div><b>Key liên kết:</b> <a :href="$filters.getExternalUrl(history.item)" target="_blank">{{ history.item.external_key }} <i class='bx bx-link'></i></a></div>
          <div><b>Đối tác:</b> {{ history.item.partner_name }}</div>
          <div><b>Vị trí:</b> {{ history.item.position }}</div>
        </div>
        <div class="px-3">
          <div><b>Tổng cost:</b> {{ $filters.comma(history.total_cost) }}</div>
          <div><b>Tổng discount:</b> {{ $filters.comma(history.total_discount) }}</div>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table fixed-left table-striped" v-if="result">
          <thead>
            <tr>
              <th>Lần chạy</th>
              <th>Ngày bắt đầu</th>
              <th>Ngày kết thúc</th>
              <th>Cost</th>
              <th>Discount</th>
              <th>Ghi chú</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(item, i) in history.logs" :key="i">
              <td>
                {{ item.times }}
              </td>
              <td>{{ item.start_at || '-' }}</td>
              <td>{{ item.end_at || '-' }}</td>
              <td>{{ $filters.comma(item.cost) }}</td>
              <td>{{ $filters.comma(item.discount) }}</td>
              <td>{{ item.note }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </b-modal>
</template>